import React, { } from "react";
import { } from 'react-redux';
import { Link } from "react-router-dom";

import {
} from '@lockerpm/design';

import {
} from "@ant-design/icons";

import {
  convertQueryToString,
  getRouterByName,
  getRouterParams,
  validateUrl,
} from '../../utils/common'

const RouterLink = (props) => {
  const {
    className = '',
    routerName = '',
    routerParams = {},
    routerQuery = {},
    label = '',
    blank = false,
    maxWidth = '100%',
  } = props;

  const currentRouter = getRouterByName(routerName)
  const newPath = currentRouter?.path ? convertQueryToString(getRouterParams(currentRouter.path, routerParams), routerQuery) : ''
  const safePath = validateUrl(newPath, true)

  return (
    <Link
      className={`cs-link ${className} text-primary text-limited`}
      style={{ maxWidth: maxWidth, flex: 1 }}
      target={blank && safePath ? '_blank' : ''}
      to={safePath || '#'}
      onClick={(e) => {
        if (!safePath) {
          e.preventDefault();
        }
      }}
      title={label}
    >
      {label}
    </Link>
  );
}

export default RouterLink;